import { render } from "./PosSalesOld2-22.vue?vue&type=template&id=6b12046c&scoped=true"
import script from "./PosSalesOld2-22.vue?vue&type=script&lang=js"
export * from "./PosSalesOld2-22.vue?vue&type=script&lang=js"

import "./PosSalesOld2-22.vue?vue&type=style&index=0&id=6b12046c&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b12046c"]])

export default __exports__